<template>
	<div class="knd-story">

		<div class="knd-achtergond">
			<lottie-player 
				ref="knd-lottie-player"
				class="knd-lottie-player"
				:src="require('@/assets/background/achtergrond2.json')" 
				background="transparent"  
				style= "width: 100%"
				speed="1"  
				loop 
				autoplay>
			</lottie-player>
		</div>

		<div class="knd-content" ref="article">

			<div class="knd-title">
				<div v-html='getContent(content, "Kop")'></div>
			</div>

			<div class="knd-language-toggle" ref="language-toggle" @click="toggleLanguage">
				<div ref="knd-language-highlight" class="knd-language-highlight"></div>
				<div ref="nl" class="knd-taal">NL</div> 
				<div ref="en" class="knd-taal twee">EN</div>
			</div>

			<div class="knd-intro2">
				<div v-html='getContent(content, "Intro")'></div>
			</div>

			<div 
				class="blockwrapper"
				v-for='(serie, index) in series'
				:key='index'>

				<!-- testimonials -->
				<div v-if='serie.length > 1 && serie[0]["Type"] === "citaat"' class="knd-citaat-wrapper">
					<div 
						v-show='!mobiel'
						class="knd-citaten">

						<template 
							v-for='stap in serie' 
							:key='stap["Naam"]'>

							<div v-if='stap["Type"] === "citaat"' class="knd-citaat">
								<img class="knd-citaat-foto" :src='getImage(stap["Afbeelding"][0].url)' />
								<p class="knd-citaat-titel" v-html='getContent(stap, "Tussenkop")'></p>
								<p v-html='getContent(stap, "Tekst")'></p>
							</div>
							
						</template>
					</div>

					<Citaatswiper 
						v-show='mobiel'
						:serie='serie' />
				</div>


				<!-- sticky scroller -->
				<Sticky 
					v-if='serie.length > 1'
					v-on:enterFn="handleEnterFn"
					v-bind:offset='0'
					triggerClass='step'
					:swiperVideos='getSwiperVideos(serie)'
					:language="$store.state.language">
				</Sticky>


				<!-- verschillende blokken -->
				<template 
					v-for='stap in serie' 
					:key='stap["Naam"]'>
					<Blokcontroller v-if='stap["Type"] === "blok"' :stap='stap' :language="$store.state.language" :mobiel='mobiel' />
				</template>

				
			</div>

			<!-- Colofon -->

			<img class="knd-colofon-img" :src='require("@/assets/images/tiktok_strooi3.png")' />

			<div class="knd-colofon">
				<div class="knd-colofon-kop">Colofon</div>
				<div class="knd-colofon-tekst"  v-html='getContent(content, "Colofon")'></div>
			</div>
		</div>


	</div>
</template>

<script>

import './../scss/index.scss';

import Sticky from './sticky';
import Citaatswiper from './citaatswiper';
import Blokcontroller from './blokcontroller';

import LottiePlayer from "@lottiefiles/lottie-player";


export default {
	name: 'Story',
	data: function() {
		return {
			content: this.$store.state.content,
			currentNum: 0,
			series: [],
			mobiel: true
		}
	},
	mounted: function() {
		this.setLanguageButton();

		//verhaal in meerdere stappen met blok opknippen
		const stappen = this.content["Stappen"];
		let blokken = []

		for (var i = 0; i < stappen.length; i++) {
			if(stappen[i]["Type"] === 'blok') {
				blokken.push(i);
			}
		}

		for (i = 0; i < blokken.length + 1; i++) {
			const start = blokken[i - 1] ? blokken[i - 1] + 1 : 0;
			const end = blokken[i] ? blokken[i] + 1 : stappen.length;
			this.series.push(stappen.slice(start, end));
		}

		setTimeout(() => {
			this.setLottieSize();
			this.mobiel = window.innerWidth < 750 ? true : false;
		}, 2000);

		window.addEventListener("resize", () => {
			setTimeout(() => {
				this.setLottieSize();
				this.mobiel = window.innerWidth < 750 ? true : false;
			}, 2000);
		});
	},
	methods: {
		handleEnterFn(el) {
			this.currentNum = +el.dataset.index;
		},

		getContent(content, label) {
			if (this.$store.state.language === "nl") {
				return content[label].data;
			}
			else {
				return content[label].data5891;	
			}
		},

		getImage(imageUrl) {
			return 'https://pointer-dev.kro-ncrv.nl/' + imageUrl;
		},

		getSwiperVideos(serie) {
			let swiperVideos = [];

			for (let i=0; i < serie.length; i++) {
				if (serie[i]["Type"] === "stap") {
					swiperVideos.push(serie[i]);
				}
			}

			return swiperVideos;
		},

		setLanguageButton() {
			const highlight = this.$refs["knd-language-highlight"];

			if (this.$store.state.language === "nl") {
				highlight.classList.remove("right");
				highlight.classList.add("left");
			}
			else {
				highlight.classList.add("right");
				highlight.classList.remove("left");
			}
		},

		toggleLanguage() {
			this.$store.commit('switchLanguage');

			this.setLanguageButton();
		},

		setLottieSize() {
			const lottie = this.$refs["knd-lottie-player"];

			if (lottie) {
				const lottieSvg = lottie.shadowRoot.querySelector("svg");

				lottieSvg.setAttribute("preserveAspectRatio", "none");
				//was: preserveAspectRatio="xMidYMid meet"
			}
		}
	},
	components: {
		Sticky,
		Blokcontroller,
		Citaatswiper
	}
}
</script>
